import { render, staticRenderFns } from "./PostSkeleton.vue?vue&type=template&id=ca5ee5e6&scoped=true&"
import script from "./PostSkeleton.vue?vue&type=script&lang=js&"
export * from "./PostSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./PostSkeleton.vue?vue&type=style&index=0&id=ca5ee5e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5ee5e6",
  null
  
)

export default component.exports